export type Professional = {
  id: string
  name: string
  title: string
  specialty: string
  distance: string
  rating: number
  reviewsCount: number
  nextAvailable: string
  fee: number
  verified: boolean
  image: string
  modes: ('Clinic' | 'Home Visit' | 'Video' | 'Chat')[]
  experience: number
  languages: string[]
  affiliation: string
  bio: string
  services: string[]
}

export const professionals: Professional[] = [
  {
    id: 'p1',
    name: 'Dr. Chinedu Okafor',
    title: 'Chief Medical Officer',
    specialty: 'General Doctor',
    distance: '2.5 km',
    rating: 4.9,
    reviewsCount: 128,
    nextAvailable: 'Today, 2:00 PM',
    fee: 15000,
    verified: true,
    image:
      'https://images.unsplash.com/photo-1622253692010-333f2da6031d?auto=format&fit=crop&q=80&w=200&h=200',
    modes: ['Clinic', 'Video', 'Chat'],
    experience: 12,
    languages: ['English', 'Igbo', 'Pidgin'],
    affiliation: 'Lagos University Teaching Hospital (LUTH)',
    bio: 'Dr. Okafor is a highly experienced general practitioner with a focus on preventive medicine and chronic disease management. He is dedicated to providing compassionate and comprehensive care to his patients.',
    services: [
      'General Consultation',
      'Chronic Disease Management',
      'Health Screenings',
      'Medical Certificates',
    ],
  },
  {
    id: 'p2',
    name: 'Dr. Amina Bello',
    title: 'Consultant Pediatrician',
    specialty: 'Pediatrics',
    distance: '4.1 km',
    rating: 4.8,
    reviewsCount: 95,
    nextAvailable: 'Tomorrow, 9:00 AM',
    fee: 20000,
    verified: true,
    image:
      'https://images.unsplash.com/photo-1643297654416-05795d62e39c?auto=format&fit=crop&q=80&w=200&h=200',
    modes: ['Clinic', 'Home Visit', 'Video'],
    experience: 8,
    languages: ['English', 'Hausa'],
    affiliation: 'Reddington Hospital, Victoria Island',
    bio: 'Dr. Bello specializes in child health, from newborns to adolescents. She is passionate about early childhood development and pediatric nutrition.',
    services: [
      'Well-child Visits',
      'Vaccinations',
      'Pediatric Illnesses',
      'Nutritional Counseling',
    ],
  },
  {
    id: 'p3',
    name: 'Nurse Folake Adeyemi',
    title: 'Senior Registered Nurse',
    specialty: 'Elderly Care',
    distance: '1.2 km',
    rating: 5.0,
    reviewsCount: 42,
    nextAvailable: 'Today, 4:30 PM',
    fee: 8000,
    verified: true,
    image:
      'https://images.unsplash.com/photo-1594824476967-48c8b964ac31?auto=format&fit=crop&q=80&w=200&h=200',
    modes: ['Home Visit', 'Chat'],
    experience: 15,
    languages: ['English', 'Yoruba'],
    affiliation: 'Whiz Home Care Network',
    bio: 'Nurse Folake has over 15 years of experience in geriatric care. She provides excellent in-home support for elderly patients, focusing on comfort, dignity, and medical adherence.',
    services: [
      'Vital Signs Monitoring',
      'Medication Administration',
      'Wound Dressing',
      'Mobility Assistance',
    ],
  },
  {
    id: 'p4',
    name: 'Dr. Tunde Bakare',
    title: 'Cardiologist',
    specialty: 'Cardiology',
    distance: '6.8 km',
    rating: 4.7,
    reviewsCount: 210,
    nextAvailable: 'Wed, 10:00 AM',
    fee: 35000,
    verified: true,
    image:
      'https://images.unsplash.com/photo-1612531386530-97286d97c2d2?auto=format&fit=crop&q=80&w=200&h=200',
    modes: ['Clinic', 'Video'],
    experience: 20,
    languages: ['English', 'Yoruba'],
    affiliation: 'Evercare Hospital, Lekki',
    bio: 'Dr. Bakare is a leading cardiologist specializing in the diagnosis and treatment of heart conditions. He utilizes the latest technologies for accurate assessments.',
    services: [
      'ECG Interpretation',
      'Hypertension Management',
      'Heart Failure Treatment',
      'Post-Heart Attack Care',
    ],
  },
  {
    id: 'p5',
    name: 'Nurse Ngozi Eze',
    title: 'Midwife / Post-natal Nurse',
    specialty: 'Maternal Care',
    distance: '3.0 km',
    rating: 4.9,
    reviewsCount: 67,
    nextAvailable: 'Today, 6:00 PM',
    fee: 10000,
    verified: true,
    image:
      'https://images.unsplash.com/photo-1651008376811-b90baee60c1f?auto=format&fit=crop&q=80&w=200&h=200',
    modes: ['Home Visit', 'Clinic', 'Chat'],
    experience: 10,
    languages: ['English', 'Igbo'],
    affiliation: 'Mother & Child Center, Ikeja',
    bio: 'Nurse Ngozi provides exceptional pre and post-natal care. She supports new mothers with lactation consulting, newborn care, and maternal recovery.',
    services: [
      'Lactation Consulting',
      'Newborn Care',
      'Post-partum Checkups',
      'Antenatal Classes',
    ],
  },
]

export const specialties = [
  'General Doctor',
  'Pediatrics',
  'Gynecology',
  'Mental Health',
  'Elderly Care Nurse',
  'Post-surgery Care',
  'Lab Technician',
  'Cardiology',
  'Dermatology',
]

export const symptomsList = [
  'Fever',
  'Cough',
  'Headache',
  'Stomach Pain',
  'Back Pain',
  'Fatigue',
  'Chest Pain',
  'Skin Rash',
  'Nausea',
  'Dizziness',
  'Sore Throat',
]

export const mockUser = {
  name: 'Oluwaseun',
  fullName: 'Oluwaseun Adebayo',
  phone: '+234 801 234 5678',
  email: 'seun.adebayo@example.com',
  location: 'Lekki Phase 1, Lagos',
  walletBalance: 45000,
}

export const familyMembers = [
  {
    id: 'f1',
    name: 'Oluwaseun Adebayo',
    relation: 'Self',
    age: 32,
    gender: 'Male',
  },
  {
    id: 'f2',
    name: 'Aisha Adebayo',
    relation: 'Spouse',
    age: 30,
    gender: 'Female',
  },
  {
    id: 'f3',
    name: 'Tomiwa Adebayo',
    relation: 'Child',
    age: 4,
    gender: 'Male',
  },
  {
    id: 'f4',
    name: 'Mrs. Grace Adebayo',
    relation: 'Parent',
    age: 65,
    gender: 'Female',
    notes: 'Hypertensive, allergic to Penicillin',
  },
]

export const mockAppointments = [
  {
    id: 'a1',
    professionalId: 'p1',
    professionalName: 'Dr. Chinedu Okafor',
    professionalImage:
      'https://images.unsplash.com/photo-1612349317150-e410f624c427?auto=format&fit=crop&q=80&w=200',
    date: 'Today, 2:00 PM',
    type: 'Video',
    status: 'upcoming',
  },
  {
    id: 'a2',
    professionalId: 'p2',
    professionalName: 'Nurse Amina Bello',
    professionalImage:
      'https://images.unsplash.com/photo-1594824436998-058a23116fc7?auto=format&fit=crop&q=80&w=200',
    date: 'Tomorrow, 10:00 AM',
    type: 'Home Visit',
    status: 'upcoming',
  },
  {
    id: 'a3',
    professionalId: 'p3',
    professionalName: 'Dr. Sarah Johnson',
    professionalImage:
      'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?auto=format&fit=crop&q=80&w=200',
    date: 'Oct 12, 2023',
    type: 'Clinic',
    status: 'completed',
  },
  {
    id: 'a4',
    professionalId: 'p4',
    professionalName: 'Dr. Emmanuel Nwachukwu',
    professionalImage:
      'https://images.unsplash.com/photo-1622253692010-333f2da6031d?auto=format&fit=crop&q=80&w=200',
    date: 'Oct 05, 2023',
    type: 'Chat',
    status: 'cancelled',
  },
]

export const mockNotifications = [
  {
    id: 'n1',
    type: 'booking',
    title: 'Booking Confirmed',
    description:
      'Your video consult with Dr. Chinedu is confirmed for 2:00 PM.',
    time: '10m ago',
    read: false,
  },
  {
    id: 'n2',
    type: 'message',
    title: 'New Message',
    description: 'Dr. Sarah: Please remember to take your medication.',
    time: '1h ago',
    read: false,
  },
  {
    id: 'n3',
    type: 'prescription',
    title: 'Prescription Ready',
    description: 'Your prescription from Dr. Chinedu is ready for order.',
    time: '2h ago',
    read: true,
  },
  {
    id: 'n4',
    type: 'payment',
    title: 'Payment Successful',
    description: '₦15,000 paid for Home Visit.',
    time: '1d ago',
    read: true,
  },
  {
    id: 'n5',
    type: 'lab',
    title: 'Lab Results Ready',
    description: 'Your Malaria test results are now available.',
    time: '2d ago',
    read: true,
  },
]

export const mockTransactions = [
  {
    id: 't1',
    date: 'Today, 1:45 PM',
    description: 'Video Consult - Dr. Chinedu',
    amount: -15000,
    status: 'success',
  },
  {
    id: 't2',
    date: 'Yesterday',
    description: 'Wallet Top-up',
    amount: 50000,
    status: 'success',
  },
  {
    id: 't3',
    date: 'Oct 12',
    description: 'Clinic Visit - Dr. Sarah',
    amount: -25000,
    status: 'success',
  },
  {
    id: 't4',
    date: 'Oct 05',
    description: 'Refund - Cancelled Chat',
    amount: 5000,
    status: 'refunded',
  },
]

export const mockPrescriptions = [
  {
    id: 'rx1',
    doctorName: 'Dr. Chinedu Okafor',
    date: 'Today',
    medications: [
      {
        name: 'Amoxicillin',
        dosage: '500mg',
        frequency: '1 capsule 3 times daily',
        duration: '5 days',
      },
      {
        name: 'Paracetamol',
        dosage: '1000mg',
        frequency: '2 tablets as needed for pain',
        duration: '3 days',
      },
    ],
  },
]

export const mockLabTests = [
  {
    id: 'l1',
    name: 'Malaria Parasite Test',
    price: 5000,
    description: 'Rapid diagnostic test for Malaria.',
  },
  {
    id: 'l2',
    name: 'Full Blood Count',
    price: 12000,
    description: 'Comprehensive blood analysis.',
  },
  {
    id: 'l3',
    name: 'Typhoid Widal Test',
    price: 6000,
    description: 'Test for typhoid fever.',
  },
  {
    id: 'l4',
    name: 'Comprehensive Wellness Panel',
    price: 45000,
    description:
      'Full body checkup including liver, kidney, and lipid profile.',
  },
]

export const mockTimelineRecords = [
  {
    id: 'r1',
    date: 'Today',
    type: 'Prescription',
    title: 'Antibiotics & Painkillers',
    provider: 'Dr. Chinedu Okafor',
    status: 'Active',
  },
  {
    id: 'r2',
    date: 'Yesterday',
    type: 'Lab Result',
    title: 'Malaria Test - Negative',
    provider: 'Whiz Labs',
    status: 'Completed',
  },
  {
    id: 'r3',
    date: 'Oct 12',
    type: 'Visit',
    title: 'General Checkup',
    provider: 'Dr. Sarah Johnson',
    status: 'Completed',
  },
]

export const additionalProfessionals: Professional[] = [
  {
    id: 'p6',
    name: 'Dr. Funmi Alabi',
    title: 'Consultant Gynecologist',
    specialty: 'Gynecology',
    distance: '3.2 km',
    rating: 4.9,
    reviewsCount: 84,
    nextAvailable: 'Available in 15 mins',
    fee: 25000,
    verified: true,
    image:
      'https://images.unsplash.com/photo-1622253692010-333f2da6031d?auto=format&fit=crop&q=80&w=200&h=200',
    modes: ['Clinic', 'Video'],
    experience: 14,
    languages: ['English', 'Yoruba'],
    affiliation: 'Lagos Island Maternity',
    bio: "Expert in women's health and maternal care.",
    services: ['Antenatal Care', 'General Gynecology'],
  },
  {
    id: 'p7',
    name: 'Dr. Dayo Ojo',
    title: 'Dermatologist',
    specialty: 'Dermatology',
    distance: '5.0 km',
    rating: 4.7,
    reviewsCount: 112,
    nextAvailable: 'Available in 30 mins',
    fee: 20000,
    verified: true,
    image:
      'https://images.unsplash.com/photo-1643297654416-05795d62e39c?auto=format&fit=crop&q=80&w=200&h=200',
    modes: ['Clinic', 'Video', 'Chat'],
    experience: 9,
    languages: ['English', 'Pidgin'],
    affiliation: 'SkinCare Clinic Lekki',
    bio: 'Specialist in skin, hair, and nail conditions.',
    services: ['Acne Treatment', 'Skin Screenings'],
  },
  {
    id: 'p8',
    name: 'Dr. Seyi Makinde',
    title: 'Clinical Psychologist',
    specialty: 'Mental Health',
    distance: '8.1 km',
    rating: 5.0,
    reviewsCount: 56,
    nextAvailable: 'Available Now',
    fee: 30000,
    verified: true,
    image:
      'https://images.unsplash.com/photo-1612531386530-97286d97c2d2?auto=format&fit=crop&q=80&w=200&h=200',
    modes: ['Video', 'Chat'],
    experience: 11,
    languages: ['English'],
    affiliation: 'MindWellness Center',
    bio: 'Providing compassionate therapy and counseling.',
    services: ['Therapy', 'Anxiety Management'],
  },
  {
    id: 'p9',
    name: 'Nurse Bisi Awolowo',
    title: 'Registered Nurse',
    specialty: 'Post-surgery Care',
    distance: '1.5 km',
    rating: 4.8,
    reviewsCount: 34,
    nextAvailable: 'Available in 1 hr',
    fee: 10000,
    verified: true,
    image:
      'https://images.unsplash.com/photo-1594824476967-48c8b964ac31?auto=format&fit=crop&q=80&w=200&h=200',
    modes: ['Home Visit'],
    experience: 7,
    languages: ['English', 'Yoruba'],
    affiliation: 'Whiz Home Care Network',
    bio: 'Dedicated to post-operative recovery and care.',
    services: ['Wound Dressing', 'Vitals Monitoring'],
  },
  {
    id: 'p10',
    name: 'Nurse Kehinde',
    title: 'Community Health Nurse',
    specialty: 'Injection Services',
    distance: '2.0 km',
    rating: 4.6,
    reviewsCount: 89,
    nextAvailable: 'Available Now',
    fee: 5000,
    verified: true,
    image:
      'https://images.unsplash.com/photo-1651008376811-b90baee60c1f?auto=format&fit=crop&q=80&w=200&h=200',
    modes: ['Home Visit', 'Clinic'],
    experience: 5,
    languages: ['English', 'Igbo'],
    affiliation: 'Lekki Health Center',
    bio: 'Experienced in administering injections and IVs.',
    services: ['IV Therapy', 'Vaccinations'],
  },
]

// Merge additional professionals into the main array for app-wide use
professionals.push(...additionalProfessionals)

export const mockPharmacies = [
  {
    id: 'ph1',
    name: 'Whiz Pharmacy (Partner)',
    distance: 'Delivery only',
    fee: 1500,
  },
  { id: 'ph2', name: 'MedPlus Pharmacy', distance: '2.1 km', fee: 1000 },
  { id: 'ph3', name: 'HealthPlus', distance: '3.5 km', fee: 1200 },
]
